// styles
import classnames from 'classnames/bind';
// components
import Typography from 'components/Typography';
// icons
import { ReactComponent as EyeIcon } from 'icons/eye.svg';
import { ReactComponent as EyeOffIcon } from 'icons/eye-off.svg';
import T from 'prop-types';
import React, { useState } from 'react';

import styles from './Input.module.scss';

const cx = classnames.bind(styles);

const Input = ({
  label,
  initValue = '',
  inputRef = {},
  type = 'text',
  name,
  errors = {},
  isPassword,
  isCheckbox,
  isRadio = false,
  actionOptionRenderer = null,
  disabled = false,
  isRequired = true,
  className,
  hasMarginBottom = true,
  helperText,
  ...props
}) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const error = errors?.[name];

  // Create unique ID for radio buttons using name and value
  const inputId = isRadio && props.value ? `${name}_${props.value}` : name;

  const handleToggleEyeClick = () => setIsPasswordVisible((prev) => !prev);

  return (
    <div className={cx('container', { 'mgb-35': hasMarginBottom },{ 'checkbox-container': isCheckbox },{ 'radio-container': isRadio })}>
      <div className={cx('labels-wrapper')}>
        {!!label && (
          <label className={cx('label', { 'mgb-5': !isCheckbox })} htmlFor={inputId}>
            {label}
            {isRequired && <span>*</span>}
          </label>
        )}
        {actionOptionRenderer?.()}
      </div>

      <div className={cx('input-wrapper', { 'checkbox-wrapper': isCheckbox || isRadio })}>
        <input
          {...inputRef}
          className={cx('input', className, { 'has-error': !!error, password: isPassword, disabled })}
          id={inputId}
          type={isPassword ? (!isPasswordVisible ? 'password' : 'text') : type}
          name={name}
          disabled={disabled}
          {...props}
        />
        {isPassword &&
          (isPasswordVisible ? (
            <EyeIcon className={cx('icon')} onClick={handleToggleEyeClick} />
          ) : (
            <EyeOffIcon className={cx('icon')} onClick={handleToggleEyeClick} />
          ))}
      </div>

      {helperText && <Typography className={styles.helperText}>{helperText}</Typography>}

      {!!error && (
        <Typography type="body-xs" className={cx('error')}>
          {error.message}
        </Typography>
      )}
    </div>
  );
};

Input.propTypes = {
  label: T.string,
  initValue: T.string,
  inputRef: T.oneOfType([T.func, T.shape({ current: T.instanceOf(Element) })]),
  type: T.string,
  errors: T.object,
  isPassword: T.bool,
  actionOptionRenderer: T.func,
  disabled: T.bool,
  inputTransformer: T.func,
  className: T.string,
  helperText: T.string,
};

export default Input;
